enum RecipientsTableColumnSize {
  Recipient = 26,
  Name = 36,
  Email = 38,
}

export default RecipientsTableColumnSize;
